<template>
  <Dialog :open="value" @close="$emit('input', false)">
    <template v-slot:title>
      <Label text="スカウト送付者の削除" size="h5" bold />
    </template>
    <FlexColumn align="center">
      <Label text="以下のスカウト送付者を削除しますか？" />
      <FlexRow align="center" justify="center">
        <UserImage :src="requestor.imageUrl" icon />
        <Label :text="requestor.lastName" />
        <Label :text="requestor.firstName" />
        <Label :text="requestor.post" />
      </FlexRow>
    </FlexColumn>
    <template v-slot:actions>
      <FlexRow align="center" justify="center" full-width>
        <TextButton @click="$emit('input', false)">キャンセル</TextButton>
        <Button outlined @click="handleSubmit">削除</Button>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import Label from "../atoms/Label";
import FlexColumn from "../atoms/FlexColumn";
import FlexRow from "../atoms/FlexRow";
import TextButton from "../atoms/TextButton";
import Button from "../atoms/Button";
import UserImage from "../atoms/UserImage";
import ApiMixin from "../../ApiMixin";
export default {
  name: "RequestorDeleteDialog",
  mixins: [ApiMixin],
  components: {UserImage, Button, TextButton, FlexRow, FlexColumn, Label, Dialog},
  props: {
    value: {
      type: Boolean
    },
    companyId: {
      type: String
    },
    requestor: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async handleSubmit() {
      await this.deleteRequestor(this.companyId, this.requestor.id)
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>

</style>